import { VoicemailConfigAPI } from '@frontend/api-voicemail-boxes';
import { useQuery } from '@frontend/react-query-helpers';
import { PickerLocation } from '@frontend/scope';

const useVoicemailBoxes = ({
  phoneTenantId,
  settingsTenantLocation,
}: {
  phoneTenantId: string;
  settingsTenantLocation: PickerLocation | undefined;
}) => {
  return useQuery({
    queryKey: [phoneTenantId, 'voicemailBoxes'],
    queryFn: () => VoicemailConfigAPI.List({ tenantId: phoneTenantId }),
    select: ({ voicemailBoxes }) => {
      let filteredBoxes = voicemailBoxes;

      if (settingsTenantLocation?.locationType === 'unify') {
        const availableLocationIds = settingsTenantLocation?.children?.map((loc) => loc.locationID) ?? [];
        filteredBoxes = availableLocationIds.length
          ? voicemailBoxes.filter((box) =>
              box.locationIds?.some((locationId) => availableLocationIds.includes(locationId))
            )
          : [];
      }
      return filteredBoxes?.sort((a, b) => a.mailbox.name.localeCompare(b.mailbox.name));
    },
    enabled: !!phoneTenantId,
    staleTime: 5 * 60 * 1000,
  });
};

export default useVoicemailBoxes;
